module.exports = __webpack_public_path__ + "static/media/house.5b6c9f9d.svg";